exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.open[data-v-782bf7e7] {\n    display: block;\n}\n@media (max-width: 768px) {\n.modal.fade .modal-dialog[data-v-782bf7e7] {\n        width: auto !important;\n}\n}\n", ""]);

